import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthGuard from '@/utils/auth.guard'
import { adminRoot } from '@/constants/config'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home'),
    redirect: `${adminRoot}`,
    meta: { loginRequired: true }
  },
  {
    path: adminRoot,
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin'),
    redirect: `${adminRoot}/categories`,
    meta: { loginRequired: true },
    /*
   define with Authorization :
   meta: { loginRequired: true, roles: [UserRole.Admin, UserRole.Editor] }
   */
    children: [
      {
        path: 'categories',
        component: () => import(/* webpackChunkName: "admin/categories" */ '@/views/admin/categories')
      },
      {
        path: 'categories/create',
        component: () => import(/* webpackChunkName: "admin/categories/create" */ '@/views/admin/categories/Create.vue')
      },
      {
        path: 'links',
        component: () => import(/* webpackChunkName: "admin/categories" */ '@/views/admin/links')
      },
      {
        path: 'links/create',
        component: () => import(/* webpackChunkName: "admin/categories/create" */ '@/views/admin/links/Create.vue')
      },
      {
        path: 'products',
        component: () => import(/* webpackChunkName: "admin/products" */ '@/views/admin/products')
      },
      {
        path: 'products/create',
        component: () => import(/* webpackChunkName: "admin/products/create" */ '@/views/admin/products/Create.vue')
      },
      {
        path: 'products/edit/:id',
        component: () => import(/* webpackChunkName: "admin/products/edit/:id" */ '@/views/admin/products/Edit.vue')
      },
      {
        path: 'product-sections',
        component: () => import(/* webpackChunkName: "admin/product-sections" */ '@/views/admin/productSections')
      },
      {
        path: 'product-sections/create',
        component: () =>
          import(/* webpackChunkName: "admin/product-sections/create" */ '@/views/admin/productSections/Create.vue')
      },
      {
        path: 'manufacturers',
        component: () => import(/* webpackChunkName: "admin/manufacturers" */ '@/views/admin/manufacturers')
      },
      {
        path: 'manufacturers/create',
        component: () =>
          import(/* webpackChunkName: "admin/manufacturers/create" */ '@/views/admin/manufacturers/Create.vue')
      },
      {
        path: 'sliders',
        component: () => import(/* webpackChunkName: "admin/sliders" */ '@/views/admin/sliders')
      },
      {
        path: 'sliders/create',
        component: () => import(/* webpackChunkName: "admin/sliders/create" */ '@/views/admin/sliders/Create.vue')
      },
      {
        path: 'hit-products',
        component: () => import(/* webpackChunkName: "admin/hit-products" */ '@/views/admin/hitProducts')
      },
      {
        path: 'hit-products/create',
        component: () =>
          import(/* webpackChunkName: "admin/hit-products/create" */ '@/views/admin/hitProducts/Create.vue')
      },
      {
        path: 'faq',
        component: () => import(/* webpackChunkName: "admin/faq" */ '@/views/admin/faq')
      },
      {
        path: 'faq/create',
        component: () => import(/* webpackChunkName: "admin/faq/create" */ '@/views/admin/faq/Create.vue')
      },
      {
        path: 'options',
        component: () => import(/* webpackChunkName: "admin/options" */ '@/views/admin/options')
      },
      {
        path: 'options/create',
        component: () => import(/* webpackChunkName: "admin/options/create" */ '@/views/admin/options/Create.vue')
      },
      {
        path: 'delivery-terms',
        component: () => import(/* webpackChunkName: "admin/delivery-terms" */ '@/views/admin/deliveryTerms')
      },
      {
        path: 'delivery-terms/create',
        component: () =>
          import(/* webpackChunkName: "admin/delivery-terms/create" */ '@/views/admin/deliveryTerms/Create.vue')
      },
      {
        path: 'districts',
        component: () => import(/* webpackChunkName: "admin/districts" */ '@/views/admin/districts')
      },
      {
        path: 'districts/create',
        component: () => import(/* webpackChunkName: "admin/districts/create" */ '@/views/admin/districts/Create.vue')
      },
      {
        path: 'payment-terms',
        component: () => import(/* webpackChunkName: "admin/payment-terms" */ '@/views/admin/paymentTerms')
      },
      {
        path: 'payment-terms/create',
        component: () =>
          import(/* webpackChunkName: "admin/payment-terms/create" */ '@/views/admin/paymentTerms/Create.vue')
      },
      {
        path: 'pages',
        component: () => import(/* webpackChunkName: "admin/pages" */ '@/views/admin/pages')
      },
      {
        path: 'pages/create',
        component: () => import(/* webpackChunkName: "admin/pages/create" */ '@/views/admin/pages/Create.vue')
      },
      {
        path: 'pages/edit/:id',
        component: () => import(/* webpackChunkName: "admin/pages/edit/:id" */ '@/views/admin/pages/Edit.vue')
      },
      {
        path: 'promocodes',
        component: () => import(/* webpackChunkName: "admin/promocodes" */ '@/views/admin/promocodes')
      },
      {
        path: 'promocodes/create',
        component: () => import(/* webpackChunkName: "admin/promocodes/create" */ '@/views/admin/promocodes/Create.vue')
      },
      {
        path: 'promocodes/edit/:id',
        component: () => import(/* webpackChunkName: "admin/promocodes/edit" */ '@/views/admin/promocodes/Edit.vue')
      },
      {
        path: 'orders',
        component: () => import(/* webpackChunkName: "admin/orders" */ '@/views/admin/orders')
      },
      {
        path: 'callback',
        component: () => import(/* webpackChunkName: "admin/callback" */ '@/views/admin/callback')
      }
    ]
  },
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth'),
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        component: () => import(/* webpackChunkName: "auth/login" */ '@/views/auth/Login')
      }
    ]
  },
  {
    path: '/error',
    component: () => import(/* webpackChunkName: "error" */ '@/views/Error')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "error" */ '@/views/Error')
  }
]

const router = new VueRouter({
  linkActiveClass: 'active',
  routes,
  mode: 'history',
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(AuthGuard)

export default router
